export const AppSite = process.env.APP_SITE as string;

export const notificationURL = process.env.NOTIFICATION_URL as string;

export const DocSite =
  (process.env.DOC_SITE as string) || "https://docs.talencat.com";

export const GoogleClientId = process.env.GOOGLE_CLIENT_ID as string;
